import * as React from 'react';
import { getContentColor } from './ProductColors';

export interface IStatusBadgeProps {
  contenu: string;
  compact?: boolean;
}

export const StatusBadge: React.FC<IStatusBadgeProps> = ({ contenu, compact }) => {
  const color = getContentColor(contenu);

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: compact ? '3px 8px' : '4px 12px',
    borderRadius: '6px',
    fontSize: compact ? '11px' : '12px',
    fontWeight: 600,
    backgroundColor: color.background,
    color: color.text,
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
    letterSpacing: '0.02em',
    minWidth: compact ? '40px' : '50px',
    textAlign: 'center',
    transition: 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease',
    cursor: 'default',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  };

  return (
    <span
      style={style}
      title={contenu}
      onMouseEnter={e => {
        (e.currentTarget as HTMLElement).style.transform = 'scale(1.06)';
        (e.currentTarget as HTMLElement).style.boxShadow = '0 3px 10px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLElement).style.transform = 'scale(1)';
        (e.currentTarget as HTMLElement).style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
      }}
    >
      {contenu || '\u2014'}
    </span>
  );
};
